import { INotification } from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/notif';

/** 푸시 알림 조회 */
export const getNotification = async () => {
  try {
    const url = `${SUB_URL}`;

    const response = await instance.get<TApiResponseData<INotification[]>>(url);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Notification] getNotification failed:', error);
    }
  }
};

export const markAsRead = async () => {
  try {
    const url = `${SUB_URL}/read`;
    const response = await instance.post<TApiResponseData<INotification[]>>(url);
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Notification] markAsRead failed:', error);
    }
  }
};

/** 미확인 알림 개수 (GET /v1/ntfctn/unread-count) — 상단 헤더 뱃지 */
export type UnreadCount = {
  unreadCount: number;
};

export const getUnreadCount = async () => {
  try {
    const response = await instance.get<TApiResponseData<UnreadCount>>('/v1/ntfctn/unread-count');
    return response.data;
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('[Notification] getUnreadCount failed:', error);
    }
  }
};
